import React from 'react';
import styled from 'styled-components';
import { Icon, Text, Tile } from '@oneaudi/unified-web-alpha-components';
import { Badges } from './Badges';
import type { Carline } from '../utils/filterUtils';
import { FuelType, VehicleType } from '../../graphql/types';
import { CardImage } from './CardImage';
import { useI18n } from '../i18n';

type Props = {
  groupName: string;
  groupId: string;
  carline: Carline;
  modelCount: number;
  onClick: (groupId: string) => void;
  dataTestId: string;
};

export const CargroupCard: React.FC<Props> = ({
  groupName,
  groupId,
  carline,
  modelCount,
  dataTestId,
  onClick,
}) => {
  const isBEV = carline.vehicleType === VehicleType.Bev;
  const imageUrl = carline.exteriorViews?.side ?? '';
  const amountCarlines = useI18n('amountCarlinesPerGroup', {
    value: modelCount,
  });
  return (
    <Tile data-testid={dataTestId} className="TileAlpha" onClick={() => onClick(groupId)}>
      <HeaderRow>
        <Text
          variant={{
            order: '1',
            style: 'normal',
            type: 'copy',
          }}
        >
          {groupName}
        </Text>
        {isBEV && (
          <Badges
            fuelTypes={[FuelType.Electrical]}
            variantContext="cargroup"
            className="BadgeCargroupCard"
          />
        )}
      </HeaderRow>

      <CardImage imageUrl={imageUrl} alt={groupName} />
      <BottomRow>
        <Text
          variant={{
            order: '3',
            style: 'normal',
            type: 'copy',
          }}
        >
          {amountCarlines}
        </Text>
        <Icon name="forward" size="xs" />
      </BottomRow>
    </Tile>
  );
};

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.spacing.fixed100};
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacing.fixed150};
  padding-inline: ${({ theme }) => theme.spacing.fixed100};
  svg {
    fill: currentColor;
    color: ${({ theme }) => theme.colors.textDefault};
  }
`;
